<template>
  <r-toggle-card
    title="Тепловая карта 3D"
    :is-open="layerStyle.hexagon.enabled"
    @toggle="toggleHeatmapLayer"
  >
    <div class="map-heatmaps__loader" v-if="layerStyle.hexagon.loading">
      <r-text type="caption">
        <i class="el-icon-loading" />
        Загрузка данных
      </r-text>
    </div>
    <div class="map-heatmaps__container" v-else>
      <div class="map-heatmaps__slider">
        <r-slider
          title="Прозрачность"
          :number="layerStyle.hexagon.opacity"
          :min="0.1"
          :max="1"
          :step="0.1"
          @change="changeProperty('opacity', $event)"
        />
      </div>
      <div class="map-heatmaps__color">
        <r-text style="margin-bottom: 4px;">
          Палитра
        </r-text>
        <div class="map-heatmaps__color-palettes">
          <el-select
            class="r-select dark palette"
            placeholder=""
            size="mini"
            :popper-append-to-body="false"
            popper-class="map-color-picker__palette-popper"
            v-model="currentPalette"
            @change="changePalette"
            value-key="id"
          >
            <template slot="prefix">
              <palette-colors
                :colors="currentPalette.value"
                :is-current="true"
              />
            </template>
            <el-option
              v-for="item in palettes"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
              <palette-colors :colors="item.value" />
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="map-heatmaps__slider">
        <r-slider
          title="Радиус"
          :number="layerStyle.hexagon.radius"
          :min="1000"
          :max="20000"
          :step="1000"
          @change="changeProperty('radius', $event)"
        />
      </div>
      <div class="map-heatmaps__slider">
        <r-slider
          title="Покрытие"
          :number="layerStyle.hexagon.coverage"
          :min="0"
          :max="1"
          :step="0.1"
          @change="changeProperty('coverage', $event)"
        />
      </div>
      <div class="map-heatmaps__slider">
        <r-slider
          title="Верхняя граница"
          :number="layerStyle.hexagon.upperPercentile"
          :min="90"
          :max="100"
          :step="1"
          @change="changeProperty('upperPercentile', $event)"
        />
      </div>
      <div class="map-heatmaps__slider">
        <r-slider
          title="Макс. высота"
          :number="layerStyle.hexagon.maxElevation"
          :min="500"
          :max="5000"
          :step="1"
          @change="changeProperty('maxElevation', $event)"
        />
      </div>
      <div class="map-heatmaps__slider">
        <r-slider
          title="Масштаб увеличения"
          :number="layerStyle.hexagon.elevationScale"
          :min="1"
          :max="400"
          :step="1"
          @change="changeProperty('elevationScale', $event)"
        />
      </div>
    </div>
  </r-toggle-card>
</template>

<script>
import PaletteColors from "../input-sources/palette-colors";
import { palettes } from "../settings-configs";

export default {
  props: ["id", "layer-style", "layer-controller", "heatmap-controller"],
  components: {
    PaletteColors
  },
  watch: {
    id: function() {
      const config = this.$store.state.map.styleConfig[this.id];
      this.conditions = config.hexagon.conditions;
      this.currentPalette = config.hexagon.currentPalette || this.palettes[0];
    }
  },
  data() {
    return {
      conditions: this.layerStyle.conditions,
      currentPalette: this.layerStyle.currentPalette || palettes[0],
      palettes
    };
  },
  methods: {
    changeProperty(property, value) {
      if (value) this.layerStyle.hexagon[property] = value;

      this.heatmapController.changeHeatmap3dProperty(this.id, property);
    },
    toggleHeatmapLayer(value) {
      this.layerStyle.hexagon.enabled = value;

      this.changePalette();
      this.layerController.toggleHexagonLayer(this.id);
    },
    changePalette() {
      this.conditions = this.currentPalette.value.map((v, i) => ({
        value: i * 0.2,
        color: v
      }));
      this.setStoreValue();
      this.changeProperty("color");
    },
    setStoreValue() {
      this.$store.commit("SET_HEATMAP_STYLE", {
        id: this.id,
        config: {
          conditions: this.conditions,
          currentPalette: this.currentPalette
        },
        field: "hexagon"
      });
    }
  }
};
</script>

<style></style>
